import React from 'react'
import { Link } from 'react-router-dom'

function About() {
  return (
    <div>
        {/* <section id="about" class="about" style={{paddingTop:"0px"}}>
                <div class="container" data-aos="fade-up">

                <div class="row no-gutters">
                    <div class="content col-xl-12 d-flex align-items-stretch">
                    <div class="content">
                        <h3>About Us</h3>
                        <p>

                        Welcome to Leo 3d engineering pvt ltd, 
                        your trusted partner for cutting-edge 3D laser scanning services. With a commitment to precision, innovation, and client satisfaction,
                        we specialize in delivering top-notch 3D scanning solutions tailored to meet the unique needs of diverse industries.
                        </p>
                       

                        <p style={{textAlign:"justify"}}> 
                        Our Expertise:
                            At Leo 3d engineering pvt ltd, we bring a wealth of expertise to the world of 3D laser scanning. 
                            Our team of skilled professionals combines technical prowess with a deep understanding of industry requirements, ensuring the delivery of accurate and comprehensive 3D scans for projects of any scale.
                            <br/>
                            <br/>
                            
                            Reality Capture With Onsite 3D Laser Scanning Services
                            At Leo3D enigineering pvt.ltd., we understand the importance of accuracy and precision when it comes to building projects. That’s why we use the latest 3D laser scanning technology to provide you with the most accurate and detailed measurements possible. Our team of experienced professionals ensures that every project is completed with the highest level of quality and attention to detail.
                            <br/>
                            <br/>
                            Our 3D laser scanning services are designed to provide you with a comprehensive view of your building project. We use cutting-edge laser scanners to  capture high-resolution images and detailed point clouds of your project site. This allows us to create accurate 3D models of your building, which can be used for a wide range of applications.
                            <br/>
                            Leo 3D’s skilled laser scan technicians use survey-grade Leica laser scanners, which are at the forefront of the industry, to gather millions of accurate data points for a structure or site.
                            <br/>
                            <br/>
                            With the help of each client, our team of in-house engineers, architects, and CAD designers develops unique deliverables that support any project’s design, planning, and execution phases.

                        </p>
                    </div>
                    </div>
                 
                </div>

                </div>
            </section> */}
            <section id="about" className="about-section">
  <div className="container">
    <div className="row">
      <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
        <div className="inner-column">
          <div className="sec-title">
            <span className="title">About Us</span>
            <h2>Welcome to Leo 3D engineering pvt ltd,</h2>
          </div>
          <div className="text">
          your trusted partner for cutting-edge 3D laser scanning services. With a commitment to precision, innovation, and client satisfaction,
 we specialize in delivering top-notch 3D scanning solutions tailored to meet the unique needs of diverse industries.
          </div>
          <div className="text">
          At Leo 3d engineering pvt ltd, we bring a wealth of expertise to the world of 3D laser scanning. 
          Our team of skilled professionals combines technical prowess with a deep understanding of industry requirements, ensuring the delivery of accurate and comprehensive 3D scans for projects of any scale.
          out by professionals by using Photoshop and adobe
          allustrator.
          </div>
          <div className="btn-box">
            <Link to="/About"><a href="#" className="theme-btn btn-style-one">
              Know More
            </a></Link>
          </div>
        </div>
      </div>
      {/* Image Column */}
      <div className="image-column col-lg-6 col-md-12 col-sm-12">
        <div className="inner-column wow fadeInLeft">
          {/* <div className="author-desc">
            <h2>Rahul Kumar Yadav</h2>
            <span>Web Developer</span>
          </div> */}
          <figure className="image-1">
            <a href="#" className="lightbox-image" data-fancybox="images">
              <img
                title=""
                src="assets/img/aboutlogo1.jpg"
                alt=""
                style={{maxWidth:"100%",height:"auto"}}
              />
            </a>
          </figure>
        </div>
      </div>
    </div>
    <div className="sec-title">
      <span className="title">Leo 3D</span>
      <h2>Reality Capture With Onsite 3D Laser Scanning Services</h2>
    </div>
    <div className="text">
    At Leo3D enigineering pvt.ltd., we understand the importance of accuracy and precision when it comes to building projects. That’s why we use the latest 3D laser scanning technology to provide you with the most accurate and detailed measurements possible. Our team of experienced professionals ensures that every project is completed with the highest level of quality and attention to detail.
    </div>
    <div className="text">
    Our 3D laser scanning services are designed to provide you with a comprehensive view of your building project. We use cutting-edge laser scanners to capture high-resolution images and detailed point clouds of your project site. This allows us to create accurate 3D models of your building, which can be used for a wide range of applications.
    </div>
    <div className="text">
    Leo 3D’s skilled laser scan technicians use survey-grade Leica laser scanners, which are at the forefront of the industry, to gather millions of accurate data points for a structure or site.
    </div>
    <div className="text">
    With the help of each client, our team of in-house engineers, architects, and CAD designers develops unique deliverables that support any project’s design, planning, and execution phases.
    </div>
   
  </div>
</section>

    </div>
  )
}

export default About